// extracted by mini-css-extract-plugin
export default {"no-permission-container":"NoPermission_no-permission-container__Fo6u8"};